import { type PartnerDisplay } from './types';

import { pageNames } from '@/modules/activityTracker/constants';

export const supportedPartners = ['adobe', 'depop-insider', 'depop-affiliates'];

const partnerDisplays: Record<string, PartnerDisplay> = {
  adobe: {
    name: 'Adobe',
    hero: {
      images: {
        desktop: 'Adobe_top_image_asset.png',
        mobile: 'Adobe_top_image_asset.png',
      },
      transparentImage: true,
    },
    intro: {
      images: ['DEPOP_LOGO_V2.png', 'ADOBE_LOGO_V2.png'],
      copy: 'Partners.Adobe.MainCopy',
    },
    useTo: {
      reasons: [
        {
          image: 'LEVEL_UP_YOUR_CONTENT.jpg',
          copy: 'Partners.Adobe.UseCopy1',
        },
        {
          image: 'IMPROVE_YOUR_LISTINGS.jpg',
          copy: 'Partners.Adobe.UseCopy2',
        },
        {
          image: 'GROW_YOUR_BRAND.jpg',
          copy: 'Partners.Adobe.UseCopy3',
        },
      ],
    },
    features: [
      { image: 'SCHEDULING_AND_SHARING.png' },
      {
        image: 'EDITING_TOOLS_AND TEMPLATES.png',
        overrideLink: 'https://adobesparkpost.app.link/tu24FyJk5Lb',
      },
      { image: 'PREMIUM_HAS_ITS_PERKS.png' },
      {
        image: 'HOW_IT_WORKS.png',
        overrideLink: `https://www.youtube.com/watch?v=uo5AvEqgalM`,
      },
    ],
    questions: {
      numberOfQuestions: 5,
    },
    tAndC: true,
  },
  'depop-insider': {
    name: 'DepopInsider',
    hero: {
      images: {
        desktop: 'depop_insider_top_banner.jpg',
        mobile: 'depop_insider_top_banner.jpg',
      },
    },
    useTo: {
      reasons: [
        {
          image: 'LEVEL_UP_YOUR_CONTENT.jpg',
          copy: 'Partners.DepopInsider.UseCopy1',
        },
        {
          image: 'host_irl_events.jpg',
          copy: 'Partners.DepopInsider.UseCopy2',
        },
        {
          image: 'GROW_YOUR_BRAND.jpg',
          copy: 'Partners.DepopInsider.UseCopy3',
        },
      ],
    },
    features: [
      {
        image: 'jakeryanfinds.jpg',
        overrideLink: 'https://www.depop.com/jakeryanfinds/',
      },
      {
        image: 'poolroomtrends.jpg',
        overrideLink: 'https://www.depop.com/poolroomtrends/ ',
      },
      {
        image: 'coolclothz4u.jpg',
        overrideLink:
          'https://www.depop.com/coolclothz4u/?brandIds=14291&productId=472452640',
      },
    ],
    questions: {
      numberOfQuestions: 6,
    },
  },
};

const defaultPartnerDisplay: PartnerDisplay = {
  name: 'Affiliates',
  hero: {
    images: {
      desktop: 'Affiliates_top_image_asset_landscape.jpg',
    },
    isSimple: true,
  },
  features: [
    {
      image: 'Affiliates_feature_1.jpg',
      overrideLink: 'https://depop.com',
    },
    {
      image: 'Affiliates_feature_2.jpg',
    },
    { image: 'Affiliates_feature_3.jpg' },
  ],
  cta: true,
};

export function getPartnerDisplay(partner: string): PartnerDisplay {
  return partnerDisplays[partner] || defaultPartnerDisplay;
}

export const pageNameByPartner: Record<string, pageNames> = {
  adobe: pageNames.PARTNER_ADOBE,
  'depop-affiliates': pageNames.PARTNER_DEPOP_AFFILIATES,
  'depop-insider': pageNames.PARTNER_DEPOP_INSIDER,
};
